var map = {
	"./bcx/logo.png": 51876,
	"./blueoak/logo.png": 2619,
	"./default/logo.png": 8538,
	"./eskom/logo.png": 39487,
	"./momentum/logo.png": 28112,
	"./tigerbrands/logo.png": 28489,
	"./tongaat/logo.png": 95259,
	"./xib-demo/logo.png": 916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54123;